<script lang="ts">
    //@TODO add booked percentage

    import { Chart, type ChartConfiguration, type ChartDataset, type ChartTypeRegistry, type Tick, type TooltipItem } from "chart.js/auto";
    import "chartjs-adapter-luxon";
    import { onMount } from "svelte";

    import jQuery from "jquery";
    import { type IStatsController } from "../../controller/IStatsController";
    import { ExampleStatsController } from "../../controller/ExampleStatsController";
    import { Booking } from "../../model/Booking";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import BookingProgress from "../components/BookingProgress.svelte";
    import { getDefaultMinimalisticStyle } from "../../utility/GraphHelper.svelte";
    import { getBrandIconPath, RemoveImageOnErrorCallback } from "../../utility/UiHelper";

    let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let bookings: Booking[] = $state();

    onMount(() => {
        let cfgMng = ConfigurationManager.getInstance();

        let bookingManager = cfgMng.bookingController;

        bookingManager.getAllBookings().then((incoming: Booking[]) => {
            bookings = incoming;
            bookings.sort((a: Booking, b: Booking) : number => {
                return a.name < b.name ? -1 : 1;
            });
        });

        const ctx = document.getElementById("salesChart");

        let exampleStatsController: IStatsController = new ExampleStatsController();

        let to = new Date(Date.now());
        to.setHours(0);
        to.setMinutes(0);
        to.setSeconds(0);
        to.setMilliseconds(0);

        let from = new Date();
        from.setDate(to.getDate() - 30);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        from.setMilliseconds(0);

        let gamesArray: string[] = ["The Matrix Awakens", "Fortnite", "Fall Guys"];

        let promises: Promise<Map<Date, number>>[] = [];

        for (let gamename of gamesArray) {
            promises.push(exampleStatsController.getDailyEarnings("fakifake", from, to));
        }
        Promise.all(promises)
            .then((resultMaps: Map<Date, number>[]) => {
                let dataSets: ChartDataset[] = [];
                let i = 0;

                // let df = new DataFrame();
                for (let result of resultMaps) {
                    let gameName = gamesArray[i++];
                    dataSets.push({
                        data: Array.from(result.values()),
                        label: gameName,
                        stack: "Stack 0",
                    });
                }

                let chartConfig1: ChartConfiguration = {
                    type: "bar",
                    data: {
                        labels: Array.from(resultMaps[0].keys()),
                        // datasets: [
                        //     {
                        //         label: "Gross Earnings",
                        //         data: Array.from(earningStats.values()),
                        //         backgroundColor: 'rgb(0,186,199)',
                        //         stack: "Stack 0"
                        //     },
                        // ],
                        datasets: dataSets,
                    },

                    options: {
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: (tooltipItem: TooltipItem<keyof ChartTypeRegistry>) => {
                                        return Math.round((tooltipItem.raw as number) * 100) / 100 + " €";
                                    },
                                },
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        interaction: {
                            intersect: false,
                        },
                        scales: {
                            x: {
                                stacked: true,
                                type: "time",
                                time: {
                                    unit: "day",
                                },
                                grid: {
                                    display: false
                                }

                            },
                            y: {
                                stacked: true,
                                ticks: {
                                    callback: (tickValue: number, index: number, ticks: Tick[]): string => {
                                        return tickValue.toLocaleString() + " €";
                                    },
                                },
                            },
                        },
                    },
                };
                new Chart(ctx as HTMLCanvasElement, chartConfig1 as ChartConfiguration);

            })
            .catch((err) => {
                console.log("Fetching earnings Failed: " + err);
            });
    });
</script>

<!-- Title -->
<h1 class="h2">Dashboard</h1>

<div class="row my-4">
    <div class="col-12 col-md-3">
        <!-- Card -->
        <div class="card h-100">
            <div class="card-body">
                <div class="row">
                    <div class="col d-flex justify-content-between">
                        <div>
                            <!-- Title -->
                            <h5 class="d-flex align-items-center text-uppercase text-body-secondary fw-semibold mb-2">
                                <span class="legend-circle-sm bg-success"></span>
                                Estimated Outstanding
                            </h5>

                            <!-- Subtitle -->
                            <h2 class="mb-0">34,240 €</h2>

                            <!-- Comment -->
                            <p class="fs-6 text-body-secondary mb-0">No additional income</p>
                        </div>

                        <span class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32"
                                ><defs
                                    ><style>
                                        .a {
                                            fill: none;
                                            stroke: currentColor;
                                            stroke-linecap: round;
                                            stroke-linejoin: round;
                                            stroke-width: 1.5px;
                                        }
                                    </style></defs
                                ><title>cash-briefcase</title><path class="a" d="M9.75,15.937c0,.932,1.007,1.688,2.25,1.688s2.25-.756,2.25-1.688S13.243,14.25,12,14.25s-2.25-.756-2.25-1.688,1.007-1.687,2.25-1.687,2.25.755,2.25,1.687" /><line class="a" x1="12" y1="9.75" x2="12" y2="10.875" /><line class="a" x1="12" y1="17.625" x2="12" y2="18.75" /><rect class="a" x="1.5" y="6.75" width="21" height="15" rx="1.5" ry="1.5" /><path class="a" d="M15.342,3.275A1.5,1.5,0,0,0,13.919,2.25H10.081A1.5,1.5,0,0,0,8.658,3.275L7.5,6.75h9Z" /></svg
                            >
                        </span>
                    </div>
                </div>
                <!-- / .row -->
            </div>
        </div>
    </div>

    <div class="col-12 col-md-3">
        <!-- card h-100-->
        <div class="card h-100">
            <div class="card-body">
                <div class="row">
                    <div class="col d-flex justify-content-between">
                        <div>
                            <!-- Title -->
                            <h5 class="d-flex align-items-center text-uppercase text-body-secondary fw-semibold mb-2">
                                <span class="legend-circle-sm bg-success"></span>
                                Rate per 1000 Impressions
                            </h5>

                            <!-- Subtitle -->
                            <h2 class="mb-0">0,30 €</h2>
                            <!-- Comment -->
                            <p class="fs-6 text-body-secondary mb-0 text-truncate">
                                <!-- Badge -->
                                <span class="badge text-bg-success-soft fs-6 fw-bold mb-n1">
                                    <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 12.75L23.25 6 16.5 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,6l-7.939,7.939a1.5,1.5,0,0,1-2.122,0l-3.128-3.128a1.5,1.5,0,0,0-2.122,0L.75,18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                    12%
                                </span>
                                from 0,28 €
                            </p>
                        </div>

                        <span class="text-primary">
                            <svg viewBox="0 0 24 24" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M18.75,14.25H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H15.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M17.25 14.25L17.25 13.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M17.25 21L17.25 20.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M3.75 14.25L8.25 14.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M8.25 14.25L8.25 6.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M11.25 9.75L11.25 8.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M5.25 14.25L5.25 9.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M7.5,20.25H2.25a1.43,1.43,0,0,1-1.5-1.415V2.335A1.575,1.575,0,0,1,2.25.75H12.879a1.5,1.5,0,0,1,1.06.439l2.872,2.872a1.5,1.5,0,0,1,.439,1.06V7.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                        </span>
                    </div>
                </div>
                <!-- / .row -->
            </div>
        </div>
    </div>

    <div class="col-12 col-md-3">
        <!-- card h-100-->
        <div class="card h-100">
            <div class="card-body">
                <div class="row justify-content-between">
                    <div class="col">
                        <!-- Title -->
                        <h5 class="text-uppercase text-body-secondary fw-semibold mb-2 d-flex align-items-center">
                            Impressions

                            <!-- Icon -->
                            <a href="javascript: void(0);" class="ms-2 text-secondary" data-bs-toggle="tooltip" title="Impressions are a metric defined as the total number of add impressions viewed.">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="14" width="14"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,0,1,0,2Z" style="fill: currentColor" /></svg>
                            </a>
                        </h5>

                        <!-- Subtitle -->
                        <h2 class="mb-0">123,598</h2>

                        <!-- Comment -->
                        <p class="fs-6 text-body-secondary mb-0">
                            <!-- Badge -->
                            <span class="badge text-bg-danger-soft fs-6 fw-bold mb-n1">
                                <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 11.25L23.25 18 16.5 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,18l-7.939-7.939a1.5,1.5,0,0,0-2.122,0l-3.128,3.128a1.5,1.5,0,0,1-2.122,0L.75,6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                9.2%
                            </span>
                            from 134,969
                        </p>
                    </div>
                    <div class="col-6 pe-0">
                        <!-- Chart -->
                        <div class="chart-container w-100 h-65px">
                            <canvas id="totalImpressionsChart"></canvas>
                        </div>
                    </div>
                </div>
                <!-- / .row -->
            </div>
        </div>
    </div>

    <div class="col-12 col-md-3">
        <!-- card h-100-->
        <div class="card h-100">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <!-- Title -->
                        <h5 class="text-uppercase text-body-secondary fw-semibold mb-2">Total</h5>

                        <!-- Subtitle -->
                        <h2 class="mb-0">74,925 €</h2>

                        <!-- Comment -->
                        <p class="fs-6 text-body-secondary mb-0 text-truncate">
                            <!-- Badge -->
                            <span class="badge text-bg-success-soft fs-6 fw-bold mb-n1">
                                <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 12.75L23.25 6 16.5 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,6l-7.939,7.939a1.5,1.5,0,0,1-2.122,0l-3.128-3.128a1.5,1.5,0,0,0-2.122,0L.75,18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                12%
                            </span>
                            from 65,934 €
                        </p>
                    </div>

                    <div class="col-6 pe-0">
                        <!-- Chart -->
                        <div class="chart-container h-70px">
                            <canvas id="totalEarningsChart"></canvas>
                        </div>
                    </div>
                </div>
                <!-- / .row -->
            </div>
        </div>
    </div>
</div>
<!-- / .row -->



<div class="row my-4">
    <div class="col-xxl-5 d-flex">
        <!-- Card -->
        <div class="card  flex-fill w-100">
            <div class="card-header  card-header-space-between">
                <!-- Title -->
                <h2 class="card-header-title h4 text-uppercase">Bookings</h2>

                <!-- Dropdown -->
                <div class="dropdown">
                    <a href="javascript: void(0);" class="dropdown-toggle no-arrow text-secondary" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="14" width="14"><g><circle cx="12" cy="3.25" r="3.25" style="fill: currentColor" /><circle cx="12" cy="12" r="3.25" style="fill: currentColor" /><circle cx="12" cy="20.75" r="3.25" style="fill: currentColor" /></g></svg>
                    </a>
                    <div class="dropdown-menu">
                        <a href="javascript: void(0);" class="dropdown-item"> Export report </a>
                        <a href="javascript: void(0);" class="dropdown-item"> Share </a>
                        <a href="javascript: void(0);" class="dropdown-item"> Action </a>
                    </div>
                </div>
            </div>

            <!-- Table -->
            <div class="table-responsive" style="max-height: 30em; overflow-y: auto;">
                <table id="projectsTable" class="table align-middle table-edge table-nowrap mb-0">
                    <thead class="thead-light">
                        <tr>
                            <th>Customer</th>
                            <th>Booking</th>
                            <th>Status</th>
                            <th class="text-end">Volume</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if bookings}
                            {#each bookings as booking, index}
                                <tr>
                                    <td>
                                        <span class="avatar avatar-xs me-2">
                                            <img src="{getBrandIconPath(booking.brand)}" class="avatar-img" onerror={RemoveImageOnErrorCallback} />
                                        </span>
                                        {booking.brand}</td
                                    >
                                    <td class="text-body-secondary">
                                        <a href="#/booking/{booking.id}">{booking.name}</a>
                                    </td>
                                    <td class="text-end">
                                        <BookingProgress booking={booking}></BookingProgress>
                                    </td>
                                    <td class="text-body-secondary font-monospace text-end">
                                        {booking.volumeTotal.toLocaleString()} €
                                    </td>
                                </tr>
                            {/each}
                        {/if}

                    </tbody>
                </table>
            </div>
            <!-- / .table-responsive -->
        </div>
    </div>

    <div class="col-xxl-7 d-flex">
        <!-- Card -->
        <div class="card  flex-fill w-100">
            <div class="card-header  card-header-space-between">
                <!-- Title -->
                <h2 class="card-header-title h4 text-uppercase">Total Ad Revenue for Epic Games, Inc.</h2>

                <!-- Label -->
                <h5 class="text-uppercase text-body-secondary fw-semibold mb-0">
                    <span class="legend-circle-lg bg-primary"></span>
                    Gross
                </h5>

                <!-- Label -->
                <!-- <h5
                    class="text-uppercase text-body-secondary fw-semibold mb-0 ms-4"
                >
                    <span class="legend-circle-lg bg-light"></span>
                    Actual
                </h5> -->
            </div>

            <div class="card-body d-flex flex-column">
                <!-- Chart -->
                <div class="chart-container flex-grow-1 h-275px">
                    <canvas id="salesChart" style="width: 100%;"></canvas>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- / .row -->
